var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'transition',
    'flex',
    'flex-1',
    'flex-row',
    'rounded-2xl',
    'h-9',
    'items-center',
    'border-2',
    'border-solid',
    'relative',
    _vm.$slots.extraContent ? 'ps-3.5' : 'px-3.5',
    _vm.borderClasses ]},[(((_vm.$attrs).type)==='checkbox')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"inputElement",class:[
      'oz-input',
      {
        '!placeholder-dark-text-300': _vm.darkMode === false,
        '!placeholder-light-text-300': _vm.darkMode === true,
        '!placeholder-dark-text-300 dark:!placeholder-light-text-300': _vm.darkMode === 'auto',
      },
      {
        '!text-dark-text-100': _vm.darkMode === false,
        '!text-light-text-100': _vm.darkMode === true,
        '!text-dark-text-100 dark:!text-light-text-100': _vm.darkMode === 'auto',
      },
      _vm.hasExtraContent ? 'input-with-extra-content' : 'input-without-extra-content',
      _vm.disabled && {
        '!placeholder-dark-text-400': _vm.darkMode === false,
        '!placeholder-light-text-400': _vm.darkMode === true,
        '!placeholder-dark-text-400 dark:!placeholder-light-text-400': _vm.darkMode === 'auto',
      },
      _vm.disabled && 'pointer-events-none' ],attrs:{"data-pw":_vm.testId,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.inputValue)?_vm._i(_vm.inputValue,null)>-1:(_vm.inputValue)},on:{"change":function($event){var $$a=_vm.inputValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inputValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inputValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inputValue=$$c}}}},'input',_vm.$attrs,false),Object.assign({}, _vm.$listeners, {focusin: _vm.focusin, focusout: _vm.focusout, blur: _vm.blur}))):(((_vm.$attrs).type)==='radio')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"inputElement",class:[
      'oz-input',
      {
        '!placeholder-dark-text-300': _vm.darkMode === false,
        '!placeholder-light-text-300': _vm.darkMode === true,
        '!placeholder-dark-text-300 dark:!placeholder-light-text-300': _vm.darkMode === 'auto',
      },
      {
        '!text-dark-text-100': _vm.darkMode === false,
        '!text-light-text-100': _vm.darkMode === true,
        '!text-dark-text-100 dark:!text-light-text-100': _vm.darkMode === 'auto',
      },
      _vm.hasExtraContent ? 'input-with-extra-content' : 'input-without-extra-content',
      _vm.disabled && {
        '!placeholder-dark-text-400': _vm.darkMode === false,
        '!placeholder-light-text-400': _vm.darkMode === true,
        '!placeholder-dark-text-400 dark:!placeholder-light-text-400': _vm.darkMode === 'auto',
      },
      _vm.disabled && 'pointer-events-none' ],attrs:{"data-pw":_vm.testId,"type":"radio"},domProps:{"checked":_vm._q(_vm.inputValue,null)},on:{"change":function($event){_vm.inputValue=null}}},'input',_vm.$attrs,false),Object.assign({}, _vm.$listeners, {focusin: _vm.focusin, focusout: _vm.focusout, blur: _vm.blur}))):_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],ref:"inputElement",class:[
      'oz-input',
      {
        '!placeholder-dark-text-300': _vm.darkMode === false,
        '!placeholder-light-text-300': _vm.darkMode === true,
        '!placeholder-dark-text-300 dark:!placeholder-light-text-300': _vm.darkMode === 'auto',
      },
      {
        '!text-dark-text-100': _vm.darkMode === false,
        '!text-light-text-100': _vm.darkMode === true,
        '!text-dark-text-100 dark:!text-light-text-100': _vm.darkMode === 'auto',
      },
      _vm.hasExtraContent ? 'input-with-extra-content' : 'input-without-extra-content',
      _vm.disabled && {
        '!placeholder-dark-text-400': _vm.darkMode === false,
        '!placeholder-light-text-400': _vm.darkMode === true,
        '!placeholder-dark-text-400 dark:!placeholder-light-text-400': _vm.darkMode === 'auto',
      },
      _vm.disabled && 'pointer-events-none' ],attrs:{"data-pw":_vm.testId,"type":(_vm.$attrs).type},domProps:{"value":(_vm.inputValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value}}},'input',_vm.$attrs,false),Object.assign({}, _vm.$listeners, {focusin: _vm.focusin, focusout: _vm.focusout, blur: _vm.blur}))),_vm._v(" "),(_vm.xValidationMessage)?_c('span',{class:[
      'absolute',
      'end-2',
      '-bottom-2',
      'transition',
      'text-12-16',
      'text-danger-100',
      'font-semibold',
      'truncate',
      'max-w-[calc(100%-1.5rem)]',
      'px-1',
      {
        'bg-light-ui-100': _vm.darkMode === false,
        'bg-dark-ui-100': _vm.darkMode === true,
        'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
      } ],attrs:{"aria-label":_vm.validationMessage,"title":_vm.validationMessage}},[_vm._v(_vm._s(_vm.validationMessage))]):_vm._e(),_vm._v(" "),_vm._t("extraContent")],2)}
var staticRenderFns = []

export { render, staticRenderFns }